/**
 * Critique Sessions GraphQL Queries
 *
 * Feature: 063-graphql-frontend
 */

import { gql } from '@apollo/client';
import { USER_BASIC_FRAGMENT, PHOTO_THUMBNAIL_FRAGMENT } from './fragments';

/**
 * Get list of critique sessions
 * Hook: useCritiqueSessions
 */
export const GET_CRITIQUE_SESSIONS = gql`
  query GetCritiqueSessions($limit: Int, $offset: Int) {
    critiqueSessions(limit: $limit, offset: $offset) {
      items {
        id
        globalId
        title
        slug
        collectionId
        createdAt
        updatedAt
        collection {
          id
          globalId
          title
          name
          slug
          photoCount
          heroPhotoId
          heroPhoto {
            id
            variants {
              id
              variantType
              storageUrl
              publicUrl
              width
              height
            }
          }
          user {
            id
            username
            displayName
          }
        }
        critiques {
          items {
            id
            globalId
            content
            photoId
            createdAt
            user {
              id
              username
            }
            photo {
              id
              variants {
                id
                variantType
                storageUrl
                publicUrl
                width
                height
              }
            }
          }
          totalCount
        }
      }
      totalCount
      hasMore
      limit
      offset
    }
  }
`;

/**
 * Get single critique session by ID
 * Hook: useCritiqueSession
 */
export const GET_CRITIQUE_SESSION = gql`
  ${USER_BASIC_FRAGMENT}
  ${PHOTO_THUMBNAIL_FRAGMENT}
  query GetCritiqueSession($id: ID!) {
    critiqueSession(id: $id) {
      id
      globalId
      title
      slug
      collectionId
      createdAt
      updatedAt
      # Feature 071: AI critique session fields
      intent
      isAiSession
      isPaused
      aiFeedbackStatus {
        pending
        completed
        failed
        total
        isComplete
      }
      # Feature 649: Feedback options
      feedbackOptions {
        enabled
        hasGeneral
        hasRating
      }
      # Feature 651: N Comments task fields
      nCommentsEnabled
      nCommentsTargetCount
      nCommentsDefaultCount
      collectionPhotoCount
      collection {
        id
        globalId
        title
        name
        slug
        user {
          ...UserBasic
        }
        items {
          items {
            id
            photo {
              ...PhotoThumbnail
            }
          }
        }
      }
      critiques {
        items {
          id
          globalId
          content
          photoId
          userId
          parentId
          editId
          createdAt
          user {
            ...UserBasic
          }
        }
        totalCount
      }
    }
  }
`;
